import { useState, useEffect, useRef, useCallback } from "react";

const API_BASE = "/api";
const TEST_USER = { email: "antonio@test.com", password: "test1234" };

// ── MeSH → Filtros (mapeo determinístico) ──────────────────────────────

const REGIONS = {
  traumatologia: [
    { id: "hombro", label: "Hombro", mesh: ["Shoulder Joint", "Shoulder Fractures", "Rotator Cuff", "Rotator Cuff Injuries", "Shoulder Dislocation", "Humeral Fractures, Proximal", "Acromioclavicular Joint"] },
    { id: "codo", label: "Codo", mesh: ["Elbow Joint", "Elbow", "Tennis Elbow", "Olecranon Process", "Radial Head", "Humeral Fractures, Distal"] },
    { id: "muneca-mano", label: "Muñeca-Mano", mesh: ["Wrist Fractures", "Radius Fractures", "Wrist Joint", "Carpal Bones", "Scaphoid Bone", "Metacarpal Bones", "Finger Injuries", "Palmar Plate", "Carpal Tunnel Syndrome", "Hand Injuries", "Hand Bones"] },
    { id: "rodilla", label: "Rodilla", mesh: ["Knee Joint", "Knee Prosthesis", "Arthroplasty, Replacement, Knee", "Osteoarthritis, Knee", "Patella", "Anterior Cruciate Ligament", "Anterior Cruciate Ligament Injuries", "Anterior Cruciate Ligament Reconstruction", "Posterior Cruciate Ligament", "Menisci, Tibial", "Patellar Ligament", "Femoral Fractures, Distal"] },
    { id: "tobillo-pie", label: "Tobillo-Pie", mesh: ["Ankle Joint", "Ankle Fractures", "Calcaneus", "Talus", "Achilles Tendon", "Foot", "Foot Diseases", "Metatarsal Bones", "Hallux Valgus", "Plantar Fasciitis", "Ankle Injuries"] },
    { id: "cadera", label: "Cadera", mesh: ["Hip Joint", "Hip Fractures", "Hip Prosthesis", "Arthroplasty, Replacement, Hip", "Femoral Neck Fractures", "Femoral Fractures", "Femur", "Femur Head", "Femur Head Necrosis", "Acetabulum", "Femoracetabular Impingement", "Hemiarthroplasty", "Osteoarthritis, Hip"] },
    { id: "columna", label: "Columna", mesh: ["Spine", "Spinal Fusion", "Spinal Diseases", "Intervertebral Disc", "Intervertebral Disc Degeneration", "Lumbar Vertebrae", "Cervical Vertebrae", "Thoracic Vertebrae", "Scoliosis", "Spinal Stenosis", "Spondylolysis", "Spondylolisthesis", "Kyphosis"] },
    { id: "infantil", label: "Infantil", mesh: ["Child", "Child, Preschool", "Osteogenesis Imperfecta", "Pediatrics", "Growth Plate"] },
    { id: "tumores", label: "Tumores", mesh: ["Osteosarcoma", "Chondrosarcoma", "Sarcoma, Ewing", "Bone Neoplasms", "Neoplasm Metastasis"] },
  ],
  oftalmologia: [
    { id: "retina", label: "Retina", mesh: ["Diabetic Retinopathy", "Retinal Detachment", "Retinal Ganglion Cells", "Retinal Pigment Epithelium", "Retinitis Pigmentosa", "Macular Degeneration", "Macular Edema", "Wet Macular Degeneration", "Stargardt Disease", "Choroidal Neovascularization", "Retinal Vessels", "Retina", "Hypertensive Retinopathy", "Epiretinal Membrane"] },
    { id: "glaucoma", label: "Glaucoma", mesh: ["Glaucoma", "Glaucoma, Open-Angle", "Glaucoma, Angle-Closure", "Glaucoma Drainage Implants", "Trabeculectomy", "Trabecular Meshwork", "Filtering Surgery", "Intraocular Pressure", "Stents", "Latanoprost"] },
    { id: "cornea", label: "Córnea", mesh: ["Cornea", "Corneal Diseases", "Corneal Transplantation", "Descemet Stripping Endothelial Keratoplasty", "Endothelium, Corneal", "Keratoconus", "Corneal Dystrophies, Hereditary"] },
    { id: "cristalino", label: "Cristalino y catarata", mesh: ["Cataract", "Cataract Extraction", "Phacoemulsification", "Lenses, Intraocular", "Lens, Crystalline"] },
    { id: "superficie", label: "Superficie ocular", mesh: ["Dry Eye Syndromes", "Conjunctivitis", "Blepharitis", "Tears", "Conjunctiva", "Meibomian Glands"] },
    { id: "oculoplastica", label: "Oculoplástica", mesh: ["Eyelids", "Orbit", "Lacrimal Apparatus", "Ptosis", "Orbital Diseases"] },
    { id: "neuro", label: "Neuro-oftalmología", mesh: ["Optic Disk", "Optic Nerve Diseases", "Papilledema", "Nerve Fibers", "Optic Nerve", "Optic Neuritis"] },
    { id: "pediatrica", label: "Oft. pediátrica", mesh: ["Strabismus", "Amblyopia"] },
  ],
  anestesiologia: [
    { id: "general", label: "Anestesia general", mesh: ["Anesthesia, General", "Anesthetics, Intravenous", "Anesthetics, Inhalation", "Propofol", "Sevoflurane", "Desflurane", "Ketamine"] },
    { id: "regional", label: "Anestesia regional", mesh: ["Anesthesia, Spinal", "Anesthesia, Epidural", "Nerve Block", "Anesthesia, Local", "Brachial Plexus Block", "Fascia Iliaca Block", "Anesthetics, Local", "Bupivacaine", "Ropivacaine", "Lidocaine"] },
    { id: "via-aerea", label: "Vía aérea", mesh: ["Airway Management", "Intubation, Intratracheal", "Laryngeal Masks", "Laryngoscopy", "Tracheostomy", "Airway Obstruction", "Difficult Airway"] },
    { id: "dolor", label: "Dolor", mesh: ["Pain Management", "Pain, Postoperative", "Chronic Pain", "Analgesics, Opioid", "Analgesics", "Analgesia, Patient-Controlled", "Analgesia, Epidural", "Nociception"] },
    { id: "criticos", label: "Cuidados críticos", mesh: ["Critical Care", "Intensive Care Units", "Respiration, Artificial", "Hemodynamics", "Shock", "Sepsis", "Resuscitation", "Cardiopulmonary Resuscitation"] },
    { id: "cardiovascular", label: "Cardiovascular", mesh: ["Hemodynamic Monitoring", "Blood Pressure", "Hypotension", "Cardiac Output", "Fluid Therapy", "Vasoconstrictor Agents", "Vasodilator Agents"] },
    { id: "obstetrica", label: "Obstétrica", mesh: ["Anesthesia, Obstetrical", "Cesarean Section", "Labor, Obstetric", "Analgesia, Obstetrical"] },
    { id: "pediatrica", label: "Pediátrica", mesh: ["Anesthesia, Pediatric", "Child", "Infant", "Adolescent"] },
  ],
};

const PATHOLOGIES = {
  traumatologia: [
    { id: "fracturas", label: "Fracturas", mesh: ["Fractures, Bone", "Femoral Fractures", "Hip Fractures", "Wrist Fractures", "Radius Fractures", "Femoral Neck Fractures", "Tibial Fractures", "Femoral Fractures, Distal", "Fracture Fixation, Internal", "Fracture Fixation, Intramedullary", "Fracture Healing", "Open Fracture Reduction", "Closed Fracture Reduction", "Bone Nails", "Bone Plates", "Bone Screws", "Bone Wires"] },
    { id: "artroplastia", label: "Artroplastia", mesh: ["Arthroplasty, Replacement, Hip", "Arthroplasty, Replacement, Knee", "Hip Prosthesis", "Knee Prosthesis", "Hemiarthroplasty", "Prosthesis Design", "Prosthesis Failure"] },
    { id: "artroscopia", label: "Artroscopia", mesh: ["Arthroscopy", "Anterior Cruciate Ligament Reconstruction"] },
    { id: "ligamentos", label: "Ligamentos y tendones", mesh: ["Anterior Cruciate Ligament", "Anterior Cruciate Ligament Injuries", "Anterior Cruciate Ligament Reconstruction", "Posterior Cruciate Ligament", "Rotator Cuff Injuries", "Tendon Injuries", "Achilles Tendon"] },
    { id: "tecnologia", label: "Tecnología quirúrgica", mesh: ["Robotic Surgical Procedures", "Surgery, Computer-Assisted", "Machine Learning", "Deep Learning", "Biosensing Techniques", "Fluoroscopy", "Finite Element Analysis"] },
    { id: "complicaciones", label: "Complicaciones", mesh: ["Postoperative Complications", "Prosthesis Failure", "Treatment Failure", "Corrosion", "Postoperative Pain", "Chronic Pain", "Patient Readmission", "Reoperation", "Drainage"] },
    { id: "farmacologia", label: "Farmacología", mesh: ["Memantine", "Analgesics, Opioid", "Pain Management", "Anti-Bacterial Agents"] },
    { id: "rehabilitacion", label: "Rehabilitación", mesh: ["Range of Motion, Articular", "Postural Balance", "Weight-Bearing", "Braces", "Splints", "Physical Therapy Modalities"] },
  ],
  oftalmologia: [
    { id: "cirugia", label: "Cirugía", mesh: ["Filtering Surgery", "Trabeculectomy", "Cataract Extraction", "Phacoemulsification", "Corneal Transplantation", "Descemet Stripping Endothelial Keratoplasty", "Vitrectomy"] },
    { id: "farmacologia", label: "Farmacología", mesh: ["Bevacizumab", "Ranibizumab", "Latanoprost", "Intravitreal Injections", "Angiogenesis Inhibitors", "Lipoxins"] },
    { id: "diagnostico", label: "Diagnóstico", mesh: ["Tomography, Optical Coherence", "Image Processing, Computer-Assisted", "Deep Learning", "Machine Learning", "Visual Acuity", "Biomarkers"] },
    { id: "genetica", label: "Genética y terapia génica", mesh: ["Genetic Therapy", "Retinitis Pigmentosa", "Stargardt Disease", "Genome-Wide Association Study", "Corneal Dystrophies, Hereditary"] },
    { id: "refractiva", label: "Cirugía refractiva", mesh: ["Refractive Surgical Procedures", "Laser Therapy", "Myopia", "Astigmatism"] },
  ],
  anestesiologia: [
    { id: "farmacologia", label: "Farmacología", mesh: ["Anesthetics", "Anesthetics, Intravenous", "Anesthetics, Inhalation", "Anesthetics, Local", "Analgesics, Opioid", "Analgesics", "Propofol", "Ketamine", "Dexmedetomidine", "Neuromuscular Blocking Agents", "Sugammadex"] },
    { id: "monitorizacion", label: "Monitorización", mesh: ["Monitoring, Physiologic", "Hemodynamic Monitoring", "Pulse Oximetry", "Capnography", "Electroencephalography", "Depth of Anesthesia", "Blood Gas Analysis"] },
    { id: "tecnicas", label: "Técnicas", mesh: ["Nerve Block", "Ultrasonography, Interventional", "Intubation, Intratracheal", "Catheterization, Central Venous", "Catheterization, Peripheral"] },
    { id: "complicaciones", label: "Complicaciones", mesh: ["Anesthesia Recovery Period", "Postoperative Nausea and Vomiting", "Intraoperative Complications", "Postoperative Complications", "Anaphylaxis", "Malignant Hyperthermia", "Awareness During Anesthesia"] },
    { id: "perioperatorio", label: "Perioperatorio", mesh: ["Perioperative Care", "Preoperative Care", "Postoperative Care", "Enhanced Recovery After Surgery", "Risk Assessment", "Preoperative Period"] },
    { id: "seguridad", label: "Seguridad del paciente", mesh: ["Patient Safety", "Medical Errors", "Checklist", "Simulation Training", "Quality Improvement"] },
  ],
};

function matchPaper(paper, specialty) {
  const regions = REGIONS[specialty] || [];
  const pathologies = PATHOLOGIES[specialty] || [];
  const meshDescs = (paper.meshTerms || []).map((t) => t.descriptor || t);

  if (meshDescs.length === 0) return { regions: [], pathologies: [] };

  return {
    regions: regions.filter((r) => r.mesh.some((m) => meshDescs.includes(m))).map((r) => r.id),
    pathologies: pathologies.filter((p) => p.mesh.some((m) => meshDescs.includes(m))).map((p) => p.id),
  };
}

// ── Utility ────────────────────────────────────────────────────────────
const fmt = (s) => {
  if (!s) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
};

const daysSince = (d) => {
  if (!d) return "";
  const diff = Date.now() - new Date(d).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Hoy";
  if (days === 1) return "Ayer";
  if (days < 7) return `Hace ${days} días`;
  if (days < 30) return `Hace ${Math.floor(days / 7)} sem`;
  return new Date(d).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

const getAuthors = (a) => (typeof a === "object" && a?.display ? a.display : a || "");

// ── Auth Screen ────────────────────────────────────────────────────────
function AuthScreen({ onAuth, specialties }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [specSlug, setSpecSlug] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    setError("");
    if (!email || !password) { setError("Email y contraseña requeridos"); return; }
    if (mode === "register" && !name) { setError("Nombre requerido"); return; }
    setLoading(true);

    try {
      const endpoint = mode === "register" ? "/api/auth/register" : "/api/auth/login";
      const body = mode === "register"
        ? { email, password, name, specialtySlug: specSlug || undefined }
        : { email, password };

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();

      if (data.token) {
        localStorage.setItem("medupdate_token", data.token);
        localStorage.setItem("medupdate_user", JSON.stringify(data.user));
        onAuth(data.token, data.user);
      } else {
        setError(data.error || "Error al iniciar sesión");
      }
    } catch (err) {
      setError("Error de conexión");
    }
    setLoading(false);
  };

  useState(() => {
    const params = new URLSearchParams(window.location.search);
    const rt = params.get("reset");
    if (rt) { setResetToken(rt); setForgotMode(true); setMode("reset"); }
  }, []);

  const handleForgot = async () => {
    setError(""); setMessage("");
    if (!email) { setError("Introduce tu email"); return; }
    setLoading(true);
    try {
      await fetch("/api/password/forgot", { method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify({email}) });
      setMessage("Si el email existe, recibirás un enlace de recuperación.");
    } catch(e) { setError("Error de conexión"); }
    setLoading(false);
  };

  const handleReset = async () => {
    setError(""); setMessage("");
    if (!newPassword || newPassword.length < 6) { setError("La contraseña debe tener al menos 6 caracteres"); return; }
    setLoading(true);
    try {
      const res = await fetch("/api/password/reset", { method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify({token: resetToken, password: newPassword}) });
      const data = await res.json();
      if (data.ok) { setMessage("Contraseña actualizada. Ya puedes iniciar sesión."); setForgotMode(false); setMode("login"); window.history.replaceState({}, "", "/"); }
      else setError(data.error);
    } catch(e) { setError("Error de conexión"); }
    setLoading(false);
  };

  const activeSpecs = specialties.filter(s => s.active);

  return (
    <div style={styles.authBg}>
      <div style={styles.landingGlow} />
      <div style={styles.authCard}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <svg width="40" height="40" viewBox="0 0 32 32" fill="none" style={{ marginBottom: 8 }}>
            <rect width="32" height="32" rx="8" fill="#1a1a2e" />
            <path d="M8 22V10l6 4v-4l6 4v-4l4 3v10H8z" fill="#4ecca3" />
          </svg>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: "#4ecca3", margin: "0 0 4px" }}>MedUpdate</h1>
          <p style={{ fontSize: 13, color: "#8b8fa3", margin: 0 }}>Resúmenes científicos con audio</p>
        </div>

        <div style={styles.authTabs}>
          <button onClick={() => { setMode("login"); setError(""); }} style={{ ...styles.authTab, ...(mode === "login" ? styles.authTabActive : {}) }}>Iniciar sesión</button>
          <button onClick={() => { setMode("register"); setError(""); }} style={{ ...styles.authTab, ...(mode === "register" ? styles.authTabActive : {}) }}>Registrarse</button>
        </div>

        {mode === "register" && (
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Nombre completo" style={styles.authInput} />
        )}
        <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" style={styles.authInput} />
        <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Contraseña" type="password" style={styles.authInput}
          onKeyDown={e => e.key === "Enter" && handleSubmit()} />

        {mode === "register" && activeSpecs.length > 0 && (
          <select value={specSlug} onChange={e => setSpecSlug(e.target.value)} style={styles.authSelect}>
            <option value="">Selecciona tu especialidad (opcional)</option>
            {activeSpecs.map(s => (
              <option key={s.slug} value={s.slug}>{s.icon} {s.name}</option>
            ))}
          </select>
        )}

        {error && <p style={styles.authError}>{error}</p>}

        {forgotMode && !resetToken ? (
          <>
            <p style={{fontSize:14,textAlign:"center",margin:"0 0 12px"}}>Introduce tu email para recuperar la contraseña</p>
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" style={styles.authInput} />
            {message && <p style={{color:"#16a34a",fontSize:13,textAlign:"center",margin:"0 0 10px"}}>{message}</p>}
            {error && <p style={styles.authError}>{error}</p>}
            <button onClick={handleForgot} disabled={loading} style={{...styles.authBtn, opacity: loading ? 0.7 : 1}}>{loading ? "Enviando..." : "Enviar enlace"}</button>
            <button onClick={() => {setForgotMode(false); setMessage(""); setError("");}} style={{background:"none",border:"none",color:"#888",fontSize:13,cursor:"pointer",marginTop:8,width:"100%",textAlign:"center"}}>Volver al login</button>
          </>
        ) : resetToken ? (
          <>
            <p style={{fontSize:14,textAlign:"center",margin:"0 0 12px"}}>Introduce tu nueva contraseña</p>
            <input value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Nueva contraseña" type="password" style={styles.authInput} />
            {message && <p style={{color:"#16a34a",fontSize:13,textAlign:"center",margin:"0 0 10px"}}>{message}</p>}
            {error && <p style={styles.authError}>{error}</p>}
            <button onClick={handleReset} disabled={loading} style={{...styles.authBtn, opacity: loading ? 0.7 : 1}}>{loading ? "Guardando..." : "Cambiar contraseña"}</button>
          </>
        ) : (
          <>
            <button onClick={handleSubmit} disabled={loading} style={{ ...styles.authBtn, opacity: loading ? 0.7 : 1 }}>
              {loading ? "Cargando..." : mode === "login" ? "Entrar" : "Crear cuenta"}
            </button>
            {mode === "login" && <button onClick={() => {setForgotMode(true); setError(""); setMessage("");}} style={{background:"none",border:"none",color:"#4ecca3",fontSize:13,cursor:"pointer",marginTop:10,width:"100%",textAlign:"center"}}>¿Olvidaste tu contraseña?</button>}
          </>
        )}
      </div>
    </div>
  );
}

// ── Quiz Modal ────────────────────────────────────────────────────────
function QuizModal({ onClose, token, specialtyId, subStatus, onUpgrade }) {
  const [quiz, setQuiz] = useState(null);
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/quiz?specialty_id=" + specialtyId, { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(data => { setQuiz(data); setLoading(false); }).catch(() => setLoading(false));
  }, [token, specialtyId]);

  const handleSubmit = async () => {
    if (!quiz) return;
    const answerArray = quiz.questions.map((_, i) => answers[i] ?? -1);
    const res = await fetch("/api/quiz/" + quiz.quizId + "/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      body: JSON.stringify({ answers: answerArray }),
    });
    const data = await res.json();
    setResults(data);
  };

  if (loading) return (
    <div style={styles.modalOverlay}><div style={styles.modal}><p style={{textAlign:"center",color:"#888"}}>Generando quiz...</p></div></div>
  );

  if (!quiz || !quiz.questions) return (
    <div style={styles.modalOverlay} onClick={onClose}><div style={styles.modal} onClick={e => e.stopPropagation()}>
      <button onClick={onClose} style={styles.modalClose}>✕</button>
      <p style={{textAlign:"center",color:"#888"}}>No hay quiz disponible esta semana</p>
    </div></div>
  );

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={{...styles.modal, maxWidth: 550}} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={styles.modalClose}>✕</button>
        <h2 style={styles.modalTitle}>Quiz semanal</h2>
        <p style={{fontSize:13,color:"#888",textAlign:"center",margin:"0 0 16px"}}>
          Semana del {quiz.weekStart} · {quiz.availableQuestions}/{quiz.totalQuestions} preguntas
        </p>

        {quiz.attempted && !results ? (
          <div style={{textAlign:"center",padding:20}}>
            <div style={{fontSize:48,marginBottom:8}}>✅</div>
            <p style={{fontSize:16,fontWeight:600}}>Ya completaste este quiz</p>
            <p style={{color:"#888"}}>Resultado: {quiz.score}/{quiz.total}</p>
          </div>
        ) : results ? (
          <div>
            <div style={{textAlign:"center",padding:"16px 0",marginBottom:16,background:"#f0fdf4",borderRadius:12}}>
              <div style={{fontSize:36,fontWeight:800,color:"#16a34a"}}>{results.score}/{results.total}</div>
              <div style={{fontSize:13,color:"#888"}}>respuestas correctas</div>
            </div>
            {results.results.map((r, i) => (
              <div key={i} style={{padding:"12px 0",borderBottom:"1px solid #eee"}}>
                <p style={{fontSize:14,fontWeight:600,margin:"0 0 6px"}}>{r.isCorrect ? "✅" : "❌"} {r.question}</p>
                <p style={{fontSize:13,color:"#555",margin:0}}>{r.explanation}</p>
              </div>
            ))}
          </div>
        ) : (
          <div>
            {quiz.questions.map((q, qi) => (
              <div key={qi} style={{marginBottom:20}}>
                <p style={{fontSize:14,fontWeight:600,margin:"0 0 10px"}}>{qi + 1}. {q.question}</p>
                {q.options.map((opt, oi) => (
                  <button key={oi} onClick={() => setAnswers(prev => ({...prev, [qi]: oi}))}
                    style={{display:"block",width:"100%",textAlign:"left",padding:"10px 14px",marginBottom:6,borderRadius:8,
                      border: answers[qi] === oi ? "2px solid #4ecca3" : "1.5px solid #e0e0e0",
                      background: answers[qi] === oi ? "#4ecca318" : "#fff",
                      fontSize:13,cursor:"pointer",transition:"all 0.15s"}}>
                    {String.fromCharCode(65 + oi)}. {opt}
                  </button>
                ))}
              </div>
            ))}

            {quiz.tierLimit && (
              <div style={{background:"#f59e0b12",border:"1px solid #f59e0b33",borderRadius:10,padding:12,marginBottom:12,textAlign:"center"}}>
                <p style={{fontSize:13,color:"#92400e",margin:"0 0 8px"}}>Actualiza a Básico para acceder a las 5 preguntas</p>
                <button onClick={onUpgrade} style={{...styles.planBtn,padding:"8px 20px",fontSize:13,display:"inline-block",width:"auto"}}>Ver planes</button>
              </div>
            )}

            <button onClick={handleSubmit}
              disabled={Object.keys(answers).length < quiz.questions.length}
              style={{...styles.authBtn, opacity: Object.keys(answers).length < quiz.questions.length ? 0.5 : 1, marginTop: 8}}>
              Enviar respuestas
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Upgrade Modal ──────────────────────────────────────────────────────
function UpgradeModal({ onClose, token }) {
  const handleCheckout = async (plan) => {
    try {
      const res = await fetch("/api/stripe/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ plan }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch (err) { console.error(err); }
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} style={styles.modalClose}>✕</button>
        <h2 style={styles.modalTitle}>Elige tu plan</h2>
        <p style={styles.modalSub}>Desbloquea todo el potencial de MedUpdate</p>

        <div style={styles.plansGrid}>
          <div style={styles.planCard}>
            <div style={styles.planName}>Free</div>
            <div style={styles.planPrice}>0€<span style={styles.planPeriod}>/mes</span></div>
            <ul style={styles.planFeatures}>
              <li>Feed con resúmenes ilimitados</li>
              <li>3 audios al mes</li>
              <li>1 pregunta quiz/semana</li>
            </ul>
            <div style={styles.planCurrent}>Plan actual</div>
          </div>

          <div style={{...styles.planCard, ...styles.planHighlight}}>
            <div style={styles.planBadge}>Popular</div>
            <div style={styles.planName}>Básico</div>
            <div style={styles.planPrice}>3,99€<span style={styles.planPeriod}>/mes</span></div>
            <ul style={styles.planFeatures}>
              <li>Audio ilimitado</li>
              <li>Favoritos</li>
              <li>Newsletter semanal</li>
              <li>Quiz completo (5 preguntas)</li>
              <li>Resúmenes personalizados</li>
            </ul>
            <button onClick={() => handleCheckout("basic")} style={styles.planBtn}>Suscribirme</button>
          </div>

          <div style={styles.planCard}>
            <div style={styles.planName}>Pro</div>
            <div style={styles.planPrice}>7,99€<span style={styles.planPeriod}>/mes</span></div>
            <ul style={styles.planFeatures}>
              <li>Todo lo del Básico</li>
              <li>Pregunta al paper (chat IA)</li>
              <li>Descarga offline</li>
              <li>Alertas inteligentes</li>
              <li>Estadísticas de lectura</li>
            </ul>
            <button onClick={() => handleCheckout("pro")} style={{...styles.planBtn, background: "#7c3aed"}}>Suscribirme</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Audio Limit Toast ──────────────────────────────────────────────────
function AudioLimitToast({ onUpgrade, onClose }) {
  return (
    <div style={styles.toast}>
      <div style={styles.toastText}>
        <strong>Has alcanzado el límite de 3 audios este mes.</strong>
        <br/>Actualiza a Básico para audio ilimitado.
      </div>
      <button onClick={onUpgrade} style={styles.toastBtn}>Ver planes</button>
      <button onClick={onClose} style={styles.toastClose}>✕</button>
    </div>
  );
}

// ── Landing Page ───────────────────────────────────────────────────────
function Landing({ specialties, onSelect, paperCounts }) {
  const active = specialties.filter((s) => s.active);
  const coming = specialties.filter((s) => !s.active);

  return (
    <div style={styles.landing}>
      <div style={styles.landingGlow} />
      <div style={styles.landingContent}>
        <div style={styles.hero}>
          <div style={styles.heroLogo}>
            <svg width="44" height="44" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="#1a1a2e" />
              <path d="M8 22V10l6 4v-4l6 4v-4l4 3v10H8z" fill="#4ecca3" />
            </svg>
          </div>
          <h1 style={styles.heroTitle}>MedUpdate</h1>
          <p style={styles.heroSub}>
            Resúmenes científicos en español con audio, puntuados por IA.
            <br />Selecciona tu especialidad.
          </p>
        </div>

        <div style={styles.gridLabel}>Especialidades activas</div>
        <div style={styles.specGrid}>
          {active.map((s, i) => (
            <button
              key={s.slug}
              onClick={() => onSelect(s.slug)}
              style={{ ...styles.specSquare, animationDelay: `${i * 0.06}s` }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = `0 12px 28px ${s.color}28`;
                e.currentTarget.style.borderColor = s.color;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                e.currentTarget.style.borderColor = "#e8e8e6";
              }}
            >
              <div style={{ ...styles.sqIcon, background: `${s.color}15` }}>{s.icon}</div>
              <div style={styles.sqName}>{s.name}</div>
              <div style={styles.sqMeta}>{paperCounts[s.slug] || 0} artículos</div>
            </button>
          ))}
        </div>

        {coming.length > 0 && (
          <>
            <div style={{ ...styles.gridLabel, marginTop: 32 }}>Próximamente</div>
            <div style={styles.specGrid}>
              {coming.map((s, i) => (
                <div key={s.slug} style={{ ...styles.specSquare, ...styles.comingSquare, animationDelay: `${(active.length + i) * 0.04}s` }}>
                  <div style={{ ...styles.sqIcon, background: "rgba(255,255,255,0.06)" }}>{s.icon}</div>
                  <div style={{ ...styles.sqName, color: "#8b8fa3" }}>{s.name}</div>
                  <div style={styles.comingBadge}>Pronto</div>
                </div>
              ))}
            </div>
          </>
        )}

        <div style={{ textAlign: "center", marginTop: 24 }}><button onClick={() => { localStorage.removeItem("medupdate_token"); localStorage.removeItem("medupdate_user"); window.location.reload(); }} style={{ background: "none", border: "none", color: "#555", fontSize: 12, cursor: "pointer", textDecoration: "underline" }}>Cerrar sesión</button></div>
        <p style={styles.landingFooter}>PubMed + Cochrane → Claude scoring → resumen español → OpenAI TTS</p>
      </div>
    </div>
  );
}

// ── Audio Player ───────────────────────────────────────────────────────
function AudioPlayer({ paper, isPlaying, onToggle, progress, duration, onSeek, audioRef, onNext, onPrev, queueInfo }) {
  if (!paper) return null;
  const pct = duration > 0 ? (progress / duration) * 100 : 0;

  return (
    <div style={styles.player}>
      <div style={styles.playerInner}>
        {queueInfo && queueInfo.total > 1 && <button onClick={onPrev} style={{background:"none",border:"none",color:queueInfo.index > 0 ? "#4ecca3" : "#555",cursor:"pointer",padding:4}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M6 6h2v12H6zm3.5 6l8.5 6V6z" transform="scale(-1,1) translate(-24,0)"/></svg>
        </button>}
        <button onClick={onToggle} style={styles.playBtn}>
          {isPlaying ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
          )}
        </button>
        {queueInfo && queueInfo.total > 1 && <button onClick={onNext} style={{background:"none",border:"none",color:queueInfo.index < queueInfo.total - 1 ? "#4ecca3" : "#555",cursor:"pointer",padding:4}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/></svg>
        </button>}
        {queueInfo && queueInfo.total > 1 && <span style={{color:"#888",fontSize:11,whiteSpace:"nowrap",marginRight:4}}>{queueInfo.index + 1}/{queueInfo.total}</span>}
        <div style={styles.playerMeta}>
          <div style={styles.playerTitle}>{paper.title?.length > 70 ? paper.title.slice(0, 70) + "…" : paper.title}</div>
          <div style={styles.playerSub}>{getAuthors(paper.authors)}</div>
        </div>
        <div style={styles.playerTime}>{fmt(progress)} / {fmt(duration)}</div>
      </div>
      <div style={styles.seekBar} onClick={(e) => { const rect = e.currentTarget.getBoundingClientRect(); onSeek((e.clientX - rect.left) / rect.width); }}>
        <div style={{ ...styles.seekProgress, width: `${pct}%` }} />
      </div>
      
    </div>
  );
}

// ── Paper Card ──────────────────────────────────────────────────────────
function PaperCard({ paper, isActive, onPlay, specialtyColor, onLike, onSave }) {
  const score = paper.aiScore || 0;
  const scoreColor = score >= 9 ? "#16a34a" : score >= 7 ? "#ca8a04" : "#9ca3af";
  const tags = paper.subtopics || [];

  return (
    <div style={{ ...styles.card, borderLeft: `3px solid ${specialtyColor}`, ...(isActive ? { background: "rgba(43,122,120,0.06)", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" } : {}) }}>
      <div style={styles.cardHeader}>
        <span style={{ ...styles.badge, background: (paper.source || "").toLowerCase() === "cochrane" ? "#7c3aed15" : "#2563eb12", color: (paper.source || "").toLowerCase() === "cochrane" ? "#7c3aed" : "#2563eb" }}>{paper.source}</span>
        {paper.evidenceLevel && <span style={styles.evidenceBadge}>{paper.evidenceLevel}</span>}
        <span style={{ ...styles.score, color: scoreColor }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 3, verticalAlign: -1 }}><path d="M12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61z" /></svg>
          {score}
        </span>
        <span style={styles.date}>{daysSince(paper.publicationDate)}</span>
      </div>
      <h3 style={styles.cardTitle}>{paper.title}</h3>
      <p style={styles.cardAuthors}>{getAuthors(paper.authors)} · <em>{paper.journal}</em></p>
      <p style={styles.cardSummary}>{paper.summary}</p>
      {paper.clinicalTakeaway && (
        <div style={styles.takeaway}><strong>Aplicación clínica:</strong> {paper.clinicalTakeaway}</div>
      )}
      <div style={styles.cardFooter}>
        <div style={styles.tags}>{tags.map((t) => <span key={t} style={styles.tag}>{t}</span>)}</div>
        <div style={styles.actions}>
          <button onClick={() => onLike(paper.id)} style={styles.actionBtn}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill={paper.userInteraction?.liked ? "#ef4444" : "none"} stroke={paper.userInteraction?.liked ? "#ef4444" : "#999"} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
            <span style={{ fontSize: 11, color: "#999" }}>{paper.stats?.likes || 0}</span>
          </button>
          <button onClick={() => onSave(paper.id)} style={styles.actionBtn}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill={paper.userInteraction?.saved ? "#2563eb" : "none"} stroke={paper.userInteraction?.saved ? "#2563eb" : "#999"} strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" /></svg>
          </button>
          {(paper.stats?.comments > 0) && (
            <span style={{ fontSize: 11, color: "#999", display: "flex", alignItems: "center", gap: 3 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              {paper.stats.comments}
            </span>
          )}
          {paper.pmid && (
            <a href={"https://pubmed.ncbi.nlm.nih.gov/" + paper.pmid + "/"} target="_blank" rel="noopener noreferrer" style={styles.pubmedLink}>
              PubMed
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{marginLeft: 3}}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            </a>
          )}
          {paper.audioDuration > 0 && (
            <button onClick={() => onPlay(paper)} style={{ ...styles.listenBtn, background: specialtyColor }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 5 }}><polygon points="5,3 19,12 5,21" /></svg>
              {fmt(paper.audioDuration)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Feed View ───────────────────────────────────────────────────────────
function FeedView({
  specialty, specialties, papers, loading, sort, setSort, search, setSearch,
  currentPaper, onPlay, onLike, onSave, onBack, regionFilter, setRegionFilter,
  pathologyFilter, setPathologyFilter, showSaved, setShowSaved, subStatus, setShowUpgrade, onPlayAll, showQuiz, setShowQuiz,
}) {
  const spec = specialties.find((s) => s.slug === specialty);
  const specColor = spec?.color || "#555";
  const currentRegions = REGIONS[specialty] || [];
  const currentPathologies = PATHOLOGIES[specialty] || [];

  const taggedPapers = papers.map((p) => ({ ...p, _match: matchPaper(p, specialty) }));

  // Count per region
  const regionCounts = {};
  currentRegions.forEach((r) => {
    regionCounts[r.id] = taggedPapers.filter((p) => p._match.regions.includes(r.id)).length;
  });

  // Count per pathology (within selected region or all)
  const pathologyCounts = {};
  const regionFiltered = regionFilter ? taggedPapers.filter((p) => p._match.regions.includes(regionFilter)) : taggedPapers;
  currentPathologies.forEach((pt) => {
    pathologyCounts[pt.id] = regionFiltered.filter((p) => p._match.pathologies.includes(pt.id)).length;
  });

  // Apply all filters
  const filtered = taggedPapers.filter((p) => {
    const matchSaved = !showSaved || p.userInteraction?.saved;
    const matchSearch = !search ||
      p.title?.toLowerCase().includes(search.toLowerCase()) ||
      (p.subtopics || []).some((t) => t.toLowerCase().includes(search.toLowerCase())) ||
      p.journal?.toLowerCase().includes(search.toLowerCase()) ||
      getAuthors(p.authors)?.toLowerCase().includes(search.toLowerCase());
    const matchRegion = !regionFilter || p._match.regions.includes(regionFilter);
    const matchPath = !pathologyFilter || p._match.pathologies.includes(pathologyFilter);
    return matchSaved && matchSearch && matchRegion && matchPath;
  });

  return (
    <div style={styles.feedRoot}>
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <button onClick={onBack} style={styles.backBtn}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4ecca3" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <div style={styles.logo}>
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="8" fill="#1a1a2e" /><path d="M8 22V10l6 4v-4l6 4v-4l4 3v10H8z" fill="#4ecca3" /></svg>
            <span style={styles.logoText}>MedUpdate</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto" }}>
            {subStatus.tier === "free" && <button onClick={() => setShowUpgrade(true)} style={styles.upgradeBtn}>Upgrade</button>}
            {subStatus.tier !== "free" && <span style={styles.tierBadge}>{subStatus.tier.toUpperCase()}</span>}
            <div style={{ ...styles.headerSpec, color: specColor, marginLeft: 0 }}><span style={{ marginRight: 4 }}>{spec?.icon}</span>{spec?.name}</div>
          </div>
        </div>
      </header>

      <main style={styles.main}>
        {/* Saved toggle */}
        <div style={styles.savedBar}>
          <button onClick={() => setShowSaved(false)} style={{ ...styles.savedBtn, ...(showSaved === false ? { background: specColor, color: "#fff" } : {}) }}>Todos</button>
          <button onClick={() => setShowSaved(true)} style={{ ...styles.savedBtn, ...(showSaved === true ? { background: specColor, color: "#fff" } : {}) }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: 4, verticalAlign: -2}}><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
            Favoritos{subStatus?.tier === "free" ? " 🔒" : ""}
          </button>
          <button onClick={() => { const saved = filtered.filter(p => p.userInteraction?.saved && p.audioDuration > 0); if (saved.length > 0) onPlayAll(saved); }} style={{...(showSaved ? {} : {display:"none"}), ...{padding: "7px 16px", borderRadius: 20, border: "none", background: "#4ecca3", color: "#1a1a2e", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", whiteSpace: "nowrap"}, display: showSaved ? "flex" : "none"}} style={{padding: "7px 16px", borderRadius: 20, border: "none", background: "#4ecca3", color: "#1a1a2e", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", whiteSpace: "nowrap"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: 4}}><polygon points="5,3 19,12 5,21"/></svg>
            Reproducir favoritos
          </button>
          <button onClick={() => setShowQuiz(true)} style={{padding:"7px 14px",borderRadius:20,border:"1.5px solid #7c3aed",background:"transparent",color:"#7c3aed",fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",whiteSpace:"nowrap"}}>
            📝 Quiz
          </button>
        </div>

        <div style={styles.toolbar}>
          <div style={styles.searchWrap}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" style={{ position: "absolute", left: 12, top: 12 }}><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por título, autor, revista..." style={styles.searchInput} />
          </div>
          <select value={sort} onChange={(e) => setSort(e.target.value)} style={styles.sortSelect}>
            <option value="ai_score">Relevancia IA</option>
            <option value="date">Más recientes</option>
          </select>
        </div>

        {/* Region filters */}
        {currentRegions.length > 0 && (
          <div style={styles.filterSection}>
            <div style={styles.filterLabel}>Localización</div>
            <div style={styles.chipBar}>
              <button onClick={() => { setRegionFilter(null); setPathologyFilter(null); }} style={{ ...styles.chip, ...(regionFilter === null ? { background: specColor, color: "#fff", borderColor: specColor } : {}) }}>
                Todas ({taggedPapers.length})
              </button>
              {currentRegions.map((r) => (
                <button key={r.id} onClick={() => { setRegionFilter(regionFilter === r.id ? null : r.id); setPathologyFilter(null); }}
                  style={{ ...styles.chip, ...(regionFilter === r.id ? { background: specColor, color: "#fff", borderColor: specColor } : {}), ...(regionCounts[r.id] === 0 && regionFilter !== r.id ? { opacity: 0.45 } : {}) }}>
                  {r.label} ({regionCounts[r.id] || 0})
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Pathology filters */}
        {currentPathologies.length > 0 && (
          <div style={styles.filterSection}>
            <div style={styles.filterLabel}>Tipo</div>
            <div style={styles.chipBar}>
              <button onClick={() => setPathologyFilter(null)} style={{ ...styles.chipSmall, ...(pathologyFilter === null ? { background: `${specColor}18`, color: specColor, borderColor: specColor } : {}) }}>
                Todos
              </button>
              {currentPathologies.map((pt) => (
                <button key={pt.id} onClick={() => setPathologyFilter(pathologyFilter === pt.id ? null : pt.id)}
                  style={{ ...styles.chipSmall, ...(pathologyFilter === pt.id ? { background: `${specColor}18`, color: specColor, borderColor: specColor } : {}), ...(pathologyCounts[pt.id] === 0 && pathologyFilter !== pt.id ? { opacity: 0.45 } : {}) }}>
                  {pt.label} ({pathologyCounts[pt.id] || 0})
                </button>
              ))}
            </div>
          </div>
        )}

        <div style={styles.stats}>
          <span style={{ color: specColor, fontWeight: 600 }}>{filtered.length}</span> artículos
          {regionFilter && <> en <strong>{currentRegions.find((r) => r.id === regionFilter)?.label}</strong></>}
          {pathologyFilter && <> · <strong>{currentPathologies.find((p) => p.id === pathologyFilter)?.label}</strong></>}
          {filtered.length > 0 && (
            <> · score medio <span style={{ fontWeight: 600 }}>{(filtered.reduce((a, b) => a + (b.aiScore || 0), 0) / filtered.length).toFixed(1)}</span></>
          )}
        </div>

        {loading ? (
          <div style={styles.loadingWrap}><div style={styles.spinner} /><p style={{ color: "#888", marginTop: 12 }}>Cargando artículos...</p></div>
        ) : (
          <div style={styles.feed}>
            {filtered.map((p) => (
              <PaperCard key={p.id} paper={p} isActive={currentPaper?.id === p.id} onPlay={onPlay} onLike={onLike} onSave={onSave} specialtyColor={specColor} />
            ))}
            {filtered.length === 0 && (
              <div style={styles.empty}>{search || regionFilter || pathologyFilter ? "No hay artículos que coincidan con los filtros." : "No hay artículos disponibles."}</div>
            )}
          </div>
        )}
      </main>
    </div>
  );
}

// ── Main App ────────────────────────────────────────────────────────────
export default function MedUpdate() {
  const [token, setToken] = useState(null);
  const [specialties, setSpecialties] = useState([]);
  const [view, setView] = useState("auth");
  const [specialty, setSpecialty] = useState(null);
  const [papers, setPapers] = useState([]);
  const [paperCounts, setPaperCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState("ai_score");
  const [search, setSearch] = useState("");
  const [regionFilter, setRegionFilter] = useState(null);
  const [pathologyFilter, setPathologyFilter] = useState(null);
  const [showSaved, setShowSaved] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showLimitToast, setShowLimitToast] = useState(false);
  const [subStatus, setSubStatus] = useState({ tier: "free", audioPlaysThisMonth: 0, canPlayAudio: true });

  const [currentPaper, setCurrentPaper] = useState(null);
  const [audioQueue, setAudioQueue] = useState([]);
  const audioQueueRef = useRef([]);
  const queueIndexRef = useRef(-1);
  const [queueIndex, setQueueIndex] = useState(-1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const mockTimerRef = useRef(null);

  // Register service worker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("medupdate_token");
    if (saved) setToken(saved);
    else setView("auth");
  }, []);

  const handleAuth = (newToken, user) => {
    setToken(newToken);
    setView("landing");
  };

  const handleLogout = () => {
    localStorage.removeItem("medupdate_token");
    localStorage.removeItem("medupdate_user");
    setToken(null);
    setView("auth");
  };

  // Fetch subscription status
  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE}/stripe/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => setSubStatus(data)).catch(() => {});
  }, [token]);

  useEffect(() => {
    fetch(`${API_BASE}/specialties`).then((r) => r.json()).then((data) => {
      if (Array.isArray(data) && data.length) setSpecialties(data.map((s) => ({ ...s, icon: s.icon || "📋", color: s.color || "#555" })));
    }).catch((err) => console.error('AUDIO ERROR:', err));
  }, []);

  useEffect(() => {
    if (!token || !specialties.length) return;
    specialties.filter((s) => s.active).forEach((s) => {
      fetch(`${API_BASE}/papers?specialty=${s.slug}&limit=100`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.json()).then((data) => { setPaperCounts((prev) => ({ ...prev, [s.slug]: data.papers?.length || 0 })); }).catch((err) => console.error('AUDIO ERROR:', err));
    });
  }, [token, specialties]);

  useEffect(() => {
    if (!token || !specialty) return;
    setLoading(true);
    fetch(`${API_BASE}/papers?specialty=${specialty}&sort=${sort}&limit=100`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json()).then((data) => { if (data.papers) { setPapers(data.papers); setPaperCounts((prev) => ({ ...prev, [specialty]: data.papers.length })); } })
      .catch(() => setPapers([])).finally(() => setLoading(false));
  }, [token, specialty, sort]);

  const handleSelectSpecialty = (slug) => { // Free: only registered specialty
    if (subStatus.tier === "free") {
      try {
        const u = JSON.parse(localStorage.getItem("medupdate_user") || "{}");
        if (u.specialty_id) {
          const userSpec = specialties.find(s => s.id === u.specialty_id);
          if (userSpec && userSpec.slug !== slug) { setShowUpgrade(true); return; }
        }
      } catch(e) {}
    }
    setSpecialty(slug); setSearch(""); setRegionFilter(null); setPathologyFilter(null); setShowSaved(false); setView("feed"); };
  const handleBack = () => { setView("landing"); setSpecialty(null); setSearch(""); setRegionFilter(null); setPathologyFilter(null); };

  const handlePlay = useCallback((paper) => {
    if (currentPaper?.id === paper.id) { setIsPlaying((p) => !p); return; }
    if (!subStatus.canPlayAudio) { setShowLimitToast(true); return; }
    console.log("PLAY:", paper.audioUrl, "TOKEN:", !!token, "REF:", !!audioRef.current); setCurrentPaper(paper); setProgress(0); setDuration(paper.audioDuration || 0); setIsPlaying(true);
    if (subStatus.tier === "free") setSubStatus(prev => ({ ...prev, audioPlaysThisMonth: prev.audioPlaysThisMonth + 1, canPlayAudio: prev.audioPlaysThisMonth + 1 < 3 }));
    // audio loading handled by useEffect
  }, [currentPaper, token]);

  // Load audio when currentPaper changes
  useEffect(() => {
    if (!currentPaper?.audioUrl || !token) return;
    const a = audioRef.current;
    if (!a) return;
    fetch(`${currentPaper.audioUrl}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob())
      .then(blob => {
        if (a._blobUrl) URL.revokeObjectURL(a._blobUrl);
        a._blobUrl = URL.createObjectURL(blob);
        a.src = a._blobUrl;
        a.load();
        a.play().catch(() => {});
      }).catch((err) => console.error('AUDIO ERROR:', err));
  }, [currentPaper, token]);

  useEffect(() => {
    const a = audioRef.current; if (!a) return;
    const onT = () => setProgress(a.currentTime); const onD = () => setDuration(a.duration); const onE = () => { setProgress(0); if (audioQueueRef.current.length > 0 && queueIndexRef.current < audioQueueRef.current.length - 1) { const next = queueIndexRef.current + 1; setQueueIndex(next); queueIndexRef.current = next; setCurrentPaper(audioQueueRef.current[next]); setDuration(audioQueueRef.current[next].audioDuration || 0); setIsPlaying(true); } else { setIsPlaying(false); setAudioQueue([]); setQueueIndex(-1); } };
    a.addEventListener("timeupdate", onT); a.addEventListener("loadedmetadata", onD); a.addEventListener("ended", onE);
    return () => { a.removeEventListener("timeupdate", onT); a.removeEventListener("loadedmetadata", onD); a.removeEventListener("ended", onE); };
  }, []);

  useEffect(() => {
    const a = audioRef.current; if (!currentPaper) return;
    if (currentPaper.audioUrl && token && a) {
      if (isPlaying) a.play().catch(() => {});
      else a.pause();
      // Media Session for lock screen / CarPlay
      if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
          title: currentPaper.title || 'MedUpdate',
          artist: (typeof currentPaper.authors === 'object' ? currentPaper.authors.display : currentPaper.authors) || 'MedUpdate',
          album: currentPaper.journal || 'MedUpdate',
        });
        navigator.mediaSession.setActionHandler('play', () => { a.play(); setIsPlaying(true); });
        navigator.mediaSession.setActionHandler('pause', () => { a.pause(); setIsPlaying(false); });
        navigator.mediaSession.setActionHandler('seekbackward', () => { a.currentTime = Math.max(0, a.currentTime - 15); });
        navigator.mediaSession.setActionHandler('seekforward', () => { a.currentTime += 15; });
      }
    }
    else { if (mockTimerRef.current) clearInterval(mockTimerRef.current); if (isPlaying) { mockTimerRef.current = setInterval(() => { setProgress((p) => { if (p >= (currentPaper.audioDuration || 180)) { setIsPlaying(false); clearInterval(mockTimerRef.current); return 0; } return p + 1; }); }, 1000); } }
    return () => { if (mockTimerRef.current) clearInterval(mockTimerRef.current); };
  }, [isPlaying, currentPaper, token]);

  useEffect(() => { audioQueueRef.current = audioQueue; }, [audioQueue]);
  useEffect(() => { queueIndexRef.current = queueIndex; }, [queueIndex]);

  const handlePlayAll = (papers) => {
    if (subStatus.tier === "free") { setShowUpgrade(true); return; }
    const withAudio = papers.filter(p => p.audioDuration > 0);
    if (withAudio.length === 0) return;
    setAudioQueue(withAudio);
    setQueueIndex(0);
    setCurrentPaper(withAudio[0]);
    setProgress(0);
    setDuration(withAudio[0].audioDuration || 0);
    setIsPlaying(true);
  };

  const handleNext = () => {
    if (queueIndex < audioQueue.length - 1) {
      const next = queueIndex + 1;
      setQueueIndex(next);
      setCurrentPaper(audioQueue[next]);
      setProgress(0);
      setDuration(audioQueue[next].audioDuration || 0);
      setIsPlaying(true);
    } else { setIsPlaying(false); setAudioQueue([]); setQueueIndex(-1); }
  };

  const handlePrev = () => {
    if (queueIndex > 0) {
      const prev = queueIndex - 1;
      setQueueIndex(prev);
      setCurrentPaper(audioQueue[prev]);
      setProgress(0);
      setDuration(audioQueue[prev].audioDuration || 0);
      setIsPlaying(true);
    }
  };
  const handleSeek = (pct) => { const t = pct * (duration || currentPaper?.audioDuration || 180); setProgress(t); if (audioRef.current && currentPaper?.audioUrl && token) audioRef.current.currentTime = t; };

  const handleLike = async (id) => {
    if (!token) return;
    try { const r = await fetch(`${API_BASE}/papers/${id}/like`, { method: "POST", headers: { Authorization: `Bearer ${token}` } }); const d = await r.json();
      setPapers((prev) => prev.map((p) => p.id === id ? { ...p, userInteraction: { ...p.userInteraction, liked: d.liked }, stats: { ...p.stats, likes: d.totalLikes } } : p));
    } catch (e) { console.error(e); }
  };

  const handleSave = async (id) => {
    if (!token) return;
    try { const r = await fetch(`${API_BASE}/papers/${id}/save`, { method: "POST", headers: { Authorization: `Bearer ${token}` } }); const d = await r.json();
      setPapers((prev) => prev.map((p) => p.id === id ? { ...p, userInteraction: { ...p.userInteraction, saved: d.saved } } : p));
    } catch (e) { console.error(e); }
  };

  return (
    <div style={styles.root}>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      {view === "auth" ? (
        <AuthScreen onAuth={handleAuth} specialties={specialties} />
      ) : view === "landing" ? (
        <Landing specialties={specialties} onSelect={handleSelectSpecialty} paperCounts={paperCounts} />
      ) : (
        <FeedView specialty={specialty} specialties={specialties} papers={papers} loading={loading}
          sort={sort} setSort={setSort} search={search} setSearch={setSearch} currentPaper={currentPaper}
          onPlay={handlePlay} onLike={handleLike} onSave={handleSave} onBack={handleBack} showSaved={showSaved} setShowSaved={setShowSaved}
          subStatus={subStatus} setShowUpgrade={setShowUpgrade} onPlayAll={handlePlayAll} showQuiz={showQuiz} setShowQuiz={setShowQuiz}
          regionFilter={regionFilter} setRegionFilter={setRegionFilter}
          showSaved={showSaved} setShowSaved={setShowSaved}
          pathologyFilter={pathologyFilter} setPathologyFilter={setPathologyFilter} />
      )}
      <audio ref={audioRef} style={{display:"none"}} />
      {subStatus.tier === "free" && <div style={{textAlign:"center",padding:"6px 0",fontSize:12,color:"#f59e0b",background:"#f59e0b12",borderRadius:8,margin:"0 16px"}}>{subStatus.audioPlaysThisMonth}/3 audios usados este mes</div>}
      {showQuiz && <QuizModal onClose={() => setShowQuiz(false)} token={token} specialtyId={specialties.find(s => s.slug === specialty)?.id} subStatus={subStatus} onUpgrade={() => { setShowQuiz(false); setShowUpgrade(true); }} />}
      {showUpgrade && <UpgradeModal onClose={() => setShowUpgrade(false)} token={token} />}
      {showLimitToast && <AudioLimitToast onUpgrade={() => { setShowLimitToast(false); setShowUpgrade(true); }} onClose={() => setShowLimitToast(false)} />}
      <AudioPlayer paper={currentPaper} isPlaying={isPlaying} onNext={handleNext} onPrev={handlePrev} queueInfo={audioQueue.length > 0 ? {index: queueIndex, total: audioQueue.length} : null} onToggle={() => setIsPlaying((p) => !p)}
        progress={progress} duration={duration || currentPaper?.audioDuration || 0} onSeek={handleSeek} audioRef={audioRef} />
    </div>
  );
}

// ── Styles ──────────────────────────────────────────────────────────────
const styles = {
  root: { fontFamily: "'IBM Plex Sans', 'Segoe UI', system-ui, sans-serif", minHeight: "100vh", color: "#1a1a2e" },
  landing: { minHeight: "100vh", background: "linear-gradient(160deg, #0f0f1e 0%, #1a1a2e 40%, #1e2a35 100%)", display: "flex", flexDirection: "column", alignItems: "center", position: "relative", overflow: "hidden", padding: "40px 20px" },
  landingGlow: { position: "absolute", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(78,204,163,0.12) 0%, transparent 70%)", top: "5%", left: "50%", transform: "translateX(-50%)", pointerEvents: "none" },
  landingContent: { position: "relative", zIndex: 1, maxWidth: 560, width: "100%" },
  hero: { textAlign: "center", marginBottom: 32 },
  heroLogo: { display: "flex", justifyContent: "center", marginBottom: 16 },
  heroTitle: { fontSize: 38, fontWeight: 800, color: "#4ecca3", margin: "0 0 12px", letterSpacing: "-1px" },
  heroSub: { fontSize: 15, color: "#8b8fa3", lineHeight: 1.6, margin: 0 },
  gridLabel: { fontSize: 12, fontWeight: 700, color: "#4ecca3", textTransform: "uppercase", letterSpacing: "1px", marginBottom: 10 },
  specGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  specSquare: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, padding: "22px 14px", background: "#fff", borderRadius: 14, border: "1.5px solid #e8e8e6", cursor: "pointer", transition: "all 0.25s ease", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", textAlign: "center", animation: "fadeUp 0.4s ease both" },
  comingSquare: { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", cursor: "default" },
  sqIcon: { width: 48, height: 48, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 },
  sqName: { fontSize: 14, fontWeight: 600, color: "#1a1a2e", lineHeight: 1.3 },
  sqMeta: { fontSize: 12, color: "#888" },
  comingBadge: { fontSize: 10, color: "#4ecca3", background: "rgba(78,204,163,0.12)", padding: "2px 8px", borderRadius: 10, fontWeight: 600 },
  landingFooter: { textAlign: "center", fontSize: 12, color: "#555", marginTop: 40, lineHeight: 1.5 },
  feedRoot: { background: "#f7f7f5", minHeight: "100vh", paddingBottom: 90, overflowX: "hidden" },
  header: { background: "#1a1a2e", padding: "12px 20px", position: "sticky", top: 0, zIndex: 100 },
  headerInner: { maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  backBtn: { background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center" },
  logo: { display: "flex", alignItems: "center", gap: 8 },
  logoText: { color: "#4ecca3", fontSize: 17, fontWeight: 700, letterSpacing: "-0.5px" },
  headerSpec: { fontSize: 11, fontWeight: 600, display: "flex", alignItems: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 120 },
  main: { maxWidth: 720, margin: "0 auto", padding: "0 12px", overflowX: "hidden" },
  toolbar: { display: "flex", gap: 10, alignItems: "center", paddingTop: 16, marginBottom: 8 },
  searchWrap: { position: "relative", flex: 1 },
  searchInput: { width: "100%", padding: "10px 12px 10px 36px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 14, background: "#fff", outline: "none", boxSizing: "border-box" },
  sortSelect: { padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 13, background: "#fff", color: "#555", cursor: "pointer", outline: "none", minWidth: 130 },
  filterSection: { marginBottom: 6 },
  filterLabel: { fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 },
  chipBar: { display: "flex", gap: 6, flexWrap: "wrap", paddingBottom: 4, maxWidth: "100%" },
  chip: { padding: "6px 14px", borderRadius: 20, border: "1.5px solid #ddd", background: "#fff", fontSize: 13, color: "#555", cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.2s", fontWeight: 500 },
  chipSmall: { padding: "4px 11px", borderRadius: 16, border: "1.5px solid #e0e0e0", background: "#fff", fontSize: 12, color: "#666", cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.2s" },
  stats: { fontSize: 13, color: "#888", padding: "8px 0 12px" },
  feed: { display: "flex", flexDirection: "column", gap: 12 },
  card: { background: "#fff", borderRadius: 12, padding: 18, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", transition: "all .2s" },
  cardHeader: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" },
  badge: { fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 6, letterSpacing: "0.3px" },
  evidenceBadge: { fontSize: 10, fontWeight: 600, padding: "2px 6px", borderRadius: 4, background: "#f0f0ee", color: "#666", textTransform: "uppercase" },
  score: { fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center" },
  date: { fontSize: 12, color: "#aaa", marginLeft: "auto" },
  cardTitle: { fontSize: 15, fontWeight: 600, lineHeight: 1.4, margin: "0 0 6px" },
  cardAuthors: { fontSize: 12.5, color: "#777", margin: "0 0 10px" },
  cardSummary: { fontSize: 13.5, lineHeight: 1.65, color: "#444", margin: "0 0 10px" },
  takeaway: { fontSize: 13, lineHeight: 1.5, color: "#1a5f3a", background: "#ecfdf5", padding: "8px 12px", borderRadius: 8, margin: "0 0 12px", borderLeft: "3px solid #22c55e" },
  cardFooter: { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 },
  tags: { display: "flex", gap: 6, flexWrap: "wrap" },
  tag: { fontSize: 11, color: "#666", background: "#f0f0ee", padding: "2px 8px", borderRadius: 6 },
  actions: { display: "flex", alignItems: "center", gap: 10 },
  actionBtn: { background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center", gap: 3 },
  listenBtn: { display: "flex", alignItems: "center", color: "#fff", border: "none", borderRadius: 20, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
  player: { position: "fixed", bottom: 0, left: 0, right: 0, background: "#1a1a2e", zIndex: 200, boxShadow: "0 -2px 20px rgba(0,0,0,0.15)" },
  playerInner: { maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 12, padding: "10px 16px 4px" },
  playBtn: { width: 40, height: 40, borderRadius: "50%", border: "none", background: "#4ecca3", color: "#1a1a2e", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  playerMeta: { flex: 1, overflow: "hidden" },
  playerTitle: { color: "#eee", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  playerSub: { color: "#888", fontSize: 11 },
  playerTime: { color: "#4ecca3", fontSize: 12, fontWeight: 600, flexShrink: 0 },
  seekBar: { height: 3, background: "#333", cursor: "pointer", marginTop: 4 },
  seekProgress: { height: "100%", background: "#4ecca3", transition: "width .3s linear" },
  savedBar: { display: "flex", gap: 8, paddingTop: 16, marginBottom: 4 },
  savedBtn: { padding: "7px 16px", borderRadius: 20, border: "1.5px solid #ddd", background: "#fff", fontSize: 13, color: "#555", cursor: "pointer", display: "flex", alignItems: "center", fontWeight: 500, transition: "all 0.2s" },
  pubmedLink: { fontSize: 12, color: "#2563eb", textDecoration: "none", display: "flex", alignItems: "center", fontWeight: 500 },
  modalOverlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  modal: { background: "#fff", borderRadius: 16, padding: "28px 24px", maxWidth: 700, width: "100%", position: "relative", maxHeight: "90vh", overflowY: "auto" },
  modalClose: { position: "absolute", top: 12, right: 16, background: "none", border: "none", fontSize: 20, color: "#999", cursor: "pointer" },
  modalTitle: { fontSize: 22, fontWeight: 700, margin: "0 0 4px", textAlign: "center" },
  modalSub: { fontSize: 14, color: "#888", margin: "0 0 20px", textAlign: "center" },
  plansGrid: { display: "grid", gridTemplateColumns: "1fr", gap: 12 },
  planCard: { border: "1.5px solid #e0e0e0", borderRadius: 12, padding: 16, position: "relative", display: "flex", flexDirection: "column" },
  planHighlight: { border: "2px solid #4ecca3", boxShadow: "0 4px 16px rgba(78,204,163,0.15)" },
  planBadge: { position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: "#4ecca3", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 10 },
  planName: { fontSize: 16, fontWeight: 700, marginBottom: 4 },
  planPrice: { fontSize: 28, fontWeight: 800, marginBottom: 12 },
  planPeriod: { fontSize: 14, fontWeight: 400, color: "#888" },
  planFeatures: { fontSize: 13, lineHeight: 1.8, color: "#555", paddingLeft: 18, margin: "0 0 16px", flex: 1 },
  planBtn: { width: "100%", padding: "10px 0", border: "none", borderRadius: 8, background: "#4ecca3", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  planCurrent: { width: "100%", padding: "10px 0", borderRadius: 8, background: "#f0f0ee", color: "#888", fontSize: 13, fontWeight: 500, textAlign: "center" },
  upgradeBtn: { padding: "4px 10px", borderRadius: 12, border: "1.5px solid #4ecca3", background: "transparent", color: "#4ecca3", fontSize: 11, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" },
  tierBadge: { padding: "3px 10px", borderRadius: 12, background: "#4ecca318", color: "#4ecca3", fontSize: 11, fontWeight: 700, letterSpacing: "0.5px" },
  toast: { position: "fixed", bottom: 80, left: "50%", transform: "translateX(-50%)", background: "#1a1a2e", color: "#fff", borderRadius: 12, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, zIndex: 250, boxShadow: "0 4px 20px rgba(0,0,0,0.3)", maxWidth: 500 },
  toastText: { fontSize: 13, lineHeight: 1.4, flex: 1 },
  toastBtn: { padding: "6px 14px", borderRadius: 8, border: "none", background: "#4ecca3", color: "#1a1a2e", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" },
  toastClose: { background: "none", border: "none", color: "#888", fontSize: 16, cursor: "pointer" },
  authBg: { minHeight: "100vh", background: "linear-gradient(160deg, #0f0f1e 0%, #1a1a2e 40%, #1e2a35 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, position: "relative", overflow: "hidden" },
  authCard: { background: "#fff", borderRadius: 16, padding: "32px 28px", maxWidth: 380, width: "100%", position: "relative", zIndex: 1 },
  authTabs: { display: "flex", marginBottom: 16, borderRadius: 10, overflow: "hidden", border: "1.5px solid #e0e0e0" },
  authTab: { flex: 1, padding: "9px 0", border: "none", background: "#f7f7f5", fontSize: 13, fontWeight: 500, color: "#888", cursor: "pointer", transition: "all 0.2s" },
  authTabActive: { background: "#1a1a2e", color: "#4ecca3", fontWeight: 600 },
  authInput: { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 14, marginBottom: 10, outline: "none", boxSizing: "border-box" },
  authSelect: { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 13, marginBottom: 10, outline: "none", boxSizing: "border-box", color: "#555", background: "#fff" },
  authError: { color: "#ef4444", fontSize: 13, margin: "0 0 10px", textAlign: "center" },
  authBtn: { width: "100%", padding: "12px 0", borderRadius: 10, border: "none", background: "#4ecca3", color: "#1a1a2e", fontSize: 15, fontWeight: 700, cursor: "pointer" },
  empty: { textAlign: "center", padding: 40, color: "#aaa", fontSize: 14 },
  loadingWrap: { textAlign: "center", padding: 60 },
  spinner: { width: 32, height: 32, border: "3px solid #e0e0e0", borderTopColor: "#4ecca3", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto" },
};
